export const SEARCH_RESULTS = 'SEARCH_RESULTS'
export const NO_VEHICLE_FOUND_BODY = 'NO_VEHICLE_FOUND_BODY'
export const SRP_RETAIL_VIEW_WARNING = 'SRP_RETAIL_VIEW_WARNING'
export const SRP_RETAIL_VIEW = 'SRP_RETAIL_VIEW'

export const DELIVERY_INFO_ERROR = 'Delivery information not available'
